import InboxItem from '@molecules/InboxItem';
import { useGetProfile } from '@sunrise-ui/api-client';
import { type IntroductionHalf } from '@sunrise-ui/api/network';
import { useAuthStore } from '@sunrise-ui/primitives';
import React from 'react';

type Props = {
  introHalves: IntroductionHalf[];
  openIntro: (id: string) => void;
  activeIntroId?: string;
};

export default function InboxItemIntro({
  introHalves,
  openIntro,
  activeIntroId,
}: Props) {
  const { currentUserId } = useAuthStore();
  const currentUserIntroHalf = introHalves.find(
    (i) => i.person.user_id === currentUserId,
  );
  const currentIntro = currentUserIntroHalf?.introduced_to;
  const otherIntroPerson = introHalves.find(
    (i) => i.person.user_id !== currentUserId,
  )?.person;
  const { data: introducerProfile } = useGetProfile(
    currentIntro?.introducer_id,
  );

  if (!currentUserIntroHalf || !currentIntro || !otherIntroPerson) return null;

  const introducerName = introducerProfile
    ? `${introducerProfile.first_name} ${introducerProfile.last_name}`
    : 'Deleted User';

  return (
    <InboxItem
      key={`message-list-item-${currentIntro.id}`}
      userId={otherIntroPerson.user_id}
      subtext={`from ${introducerName}`}
      timestamp={currentIntro.created_date as string}
      onPress={() => {
        if (currentIntro.id) openIntro(currentIntro.id);
      }}
      isActive={activeIntroId === currentIntro.id}
    />
  );
}
